import './App.css';
import { UserOnboard } from './pages/userOnboard';

export default function App() {
  return (
    <div className="App">
      <UserOnboard />
    </div>
  );
}
